import { InsiteModelResult } from "interface/util"

/**
 * 論文
 */
export type ArticleResult = {
  articleId: number,
  source: string
  linkId: string | null
  title: string | null
  titleJpn: string | null
  publicationType?: ArticlesPubTypeResult[]
  articleDate: string
  completedDate: string
  revicedDate: string
  journal: {
    title: string | null
    issn: string | null
    issue: string | null
    dateText: string | null
    //date: string | null
  }
  pagination: string | null
  abstract: string | null
  abstractJpn: string | null
	copyright:string | null
	coiStatement: string | null
  sections?: ArticlesSectionResult[]
  referenceCount: number
  url: string | null
  linkoutUrl?: string | null
  authorType?: number
  words?: string[]
  meshs?: ArticlesMeshResult[]
  authors?: ArticlesAuthorResult[]
} & InsiteModelResult

export type ArticleResultList = {
	list: ArticleResult[]
}

/**
 * 出版タイプ
 */
export type ArticlesPubTypeResult = {
  name: string
  code: string | null
}

/**
 * セクション
 */
export type ArticlesSectionResult = {
  label: string | null
  category: string | null
  text: string
  textJpn: string | null
}

/**
 * メッシュ
 */
export type ArticlesMeshResult = {
  description: string
  descriptionJpn: string | null
  isMajor: boolean
  uiCode: string | null
}

/**
 * 著者
 */
export type ArticlesAuthorResult = {
  authorId: number
  authorType: number
  position: number
  kojinCode: string | null
  seibetuCode?: string
  seinenGappi?: string
  nenrei?: number
  accuracy: number
  authorName: string | null
  sotukouCode?: string
  sotukouName?: string
  sotukouShortName?: string
  affilations?: ArticlesAuthorAffiliationResult[]
  sisetuList?: {
    sisetuCode: string
    sisetuName: string
    prefecture?: string
    bedCount?: number
    buka?: {
      code: string
      name?: string
    }
    yakusyoku?: {
      code: string
      name?: string
    }
  }[]
  globalRank: number
  score: number
  deviation: number
	farTimeScore: number | null
	farTimeCount: number | null
	middleTimeScore: number | null
	middleTimeCount: number | null
	nearTimeScore: number | null
	nearTimeCount: number | null
	counts: {
		single: number
		first: number
		second: number
		last: number
		lastSecond: number
		total: number
	}
}

export type ArticlesAuthor = Omit<ArticlesAuthorResult, 'sisetuList'> & {
  buka?: {
    code: string
    name?: string
  }
  yakusyoku?: {
    code: string
    name?: string
  }
}

export const AuthorType = {
  None: 0,
  SingleAuthor: 1,
  FirstAuthor: 2,
  SecondAuthor: 3,
  LastAuthor: 4,
  LastSecondAuthor: 5,
} as const

/**
 * 著者の所属
 */
export type ArticlesAuthorAffiliationResult = {
  affilationName: string
  affilationType: number
  firstDate: string
  lastDate: string
  count: number
}
